<section id="home-work">
	<nh-mw-sidebar [entries]="entries" [entry]="entry" [entryState]="entryState" (entryChange)="closeEntry($event)"></nh-mw-sidebar>
	@defer (on viewport; when forceLoad) {
		<nh-mw-entries [entries]="entries" [entryState]="entryState" @deferState></nh-mw-entries>
	} @placeholder {
		<div class="defer-ph"></div>
	}
	<div class="clearfix"></div>
</section>